"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSpecialStampDutyTax = exports.getDiscountedAdValoremStampDutyRate = exports.amortizeInverse = exports.amortize = void 0;
exports.amortize = function (amount, monthRate, totalTerm) { return (amount * monthRate) / (1 - Math.pow(1 + monthRate, -totalTerm)); };
exports.amortizeInverse = function (amorized, monthRate, totalTerm) { return (1 - Math.pow(1 + monthRate, -totalTerm)) * amorized / monthRate; };
exports.getDiscountedAdValoremStampDutyRate = function (price, table) {
    var row = table.find(function (it) { return price >= it.value; });
    if (!row)
        return 0;
    return row.k + (price - row.m) * row.r / 100;
};
exports.getSpecialStampDutyTax = function (price, month, table) {
    if (month === -1)
        return 0; // unknown last transaction date
    var row = table.find(function (it) { return month <= it.month; });
    if (!row)
        return 0; // more that certain period, no tax incurred
    return row.r / 100 * price;
};
